import React from 'react';

function UnsubscribeThanks({ size }) {
  return (
    <div className={`subscribe-${size}-form`}>
      <hr className={`subscribe-${size}-border`} />
      <div className={`unsubscribe-${size}-thanks-image`} />
      <p className={`unsubscribe-${size}-thanks-lead`}>You are now<br />unsubscribed.</p>
      <p className={`unsubscribe-${size}-thanks-message`}>Feel free to come back<br />anytime!</p>
    </div>
  );
}

export default UnsubscribeThanks;
